// extracted by mini-css-extract-plugin
export default {"content":"J8Z6ez","title":"MhpzeI","image":"bd1cKL","text":"riPXBB"};